import React from 'react';

/**
 * Wrapper component to prevent its children from being included in search engine snippets.
 */
export interface NoSnippetProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * Element type to render. Defaults to 'div'.
   */
  component?: React.ElementType;
}

export const NoSnippet: React.FC<React.PropsWithChildren<NoSnippetProps>> = ({
  component: Component = 'div',
  children,
  ...rest
}) => (
  <Component data-nosnippet {...rest}>
    {children}
  </Component>
);